app.controller('BrowseLayoutTileController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    $scope.tile_model = $rootScope.factory.tile.getModel($scope.navigation_ids);

    let haveImages = false;
    const choiceList = $scope.tile_model.choiceList();
    for (let i = 0; i < choiceList.length; i++) {
        const choice = choiceList[i];
        if (choice.getImgSrc()) {
            haveImages = true;
            break;
        }
    }
    $scope.have_tile_images = haveImages;

}])